import React from 'react';

const CaretUpIcon = ({ size = 8, ...props }) => (
  <svg
    width={Math.round((size * 12) / 8)}
    height={size}
    viewBox='0 0 12 8'
    fill='currentColor'
    {...props}>
    <path d='M7.1488 0.192196L11.8104 5.50626C12.0352 5.76256 11.9842 6.17807 11.6964 6.43434L11.0005 7.05414C10.7132 7.30999 10.2985 7.31049 10.0734 7.05523L6.35918 2.84375L1.61076 7.05526C1.32296 7.31051 0.908352 7.31002 0.683912 7.05417L0.140213 6.43436C-0.0846107 6.17807 -0.0335916 5.76256 0.254167 5.50629L6.22072 0.192223C6.50846 -0.0640699 6.92397 -0.0640697 7.1488 0.192196Z' />
  </svg>
);

export default CaretUpIcon;
